import React, { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import ConfirmModal from "../components/ConfirmModal"; // Import Reusable Modal
import "../assets/ListingModal.css";

function Shippingchargeslist() {
  const [shippinglist, setshippinglist] = useState([]);
  const token = sessionStorage.getItem("token");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const filteredData = shippinglist.filter((item) =>
    Object.values(item).some(
      (val) =>
        val &&
        typeof val === "string" &&
        val.toLowerCase().includes(search.toLowerCase())
    )
  );

  const offset = currentPage * itemsPerPage;
  const paginatedData = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const fetchShippingList = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}api/shippinglist`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setshippinglist(response.data?.data || []);
    } catch (error) {
      toast.error(
        "Error fetching data: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  const handleDeleteShipping = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/deleteshipping/${deleteId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        toast.success("Shipping Charges deleted successfully!");
        fetchShippingList();
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to delete Shipping Charges");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    }
    setShowModal(false);
  };

  useEffect(() => {
    fetchShippingList();
  }, []);

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Shipping List</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="breadcrumb-item active">Shipping List</li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  {/* Search and Entries Per Page */}
                  <div className="datatable-top d-flex justify-content-between align-items-center pt-4">
                    <div className="datatable-dropdown w-100">
                      <label className="me-2">
                        Show{" "}
                        <select
                          className="datatable-selector"
                          value={itemsPerPage}
                          onChange={(e) =>
                            setItemsPerPage(Number(e.target.value))
                          }
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="-1">All</option>
                        </select>{" "}
                        entries
                      </label>
                    </div>
                    <div className="datatable-search">
                      <input
                        className="form-control"
                        placeholder="Search..."
                        type="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Table */}
                  <div className="datatable-container overflow-auto">
                    <table
                      className="table datatable table-bordered table-striped table-responsive"
                      style={{
                        width: "100%",
                        tableLayout: "auto",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th>Pincode</th>
                          <th>Shipping Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.length > 0 ? (
                          paginatedData.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.Pincode}</td>
                              <td>{item.Shipping_Amount}</td>
                              <td>
                                <div className="d-flex gap-2">
                                  <Link to={`/updateshipping/${item._id}`}>
                                    <i className="bi bi-pencil-square text-primary"></i>
                                  </Link>
                                  <Link
                                    onClick={() => {
                                      setDeleteId(item._id);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="bi bi-trash text-danger"></i>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No matching records found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="datatable-bottom d-flex justify-content-between align-items-center">
                    <span className="w-100">
                      Showing {offset + 1} to {offset + paginatedData.length} of{" "}
                      {filteredData.length} entries
                    </span>

                    <ReactPaginate
                      previousLabel={"‹"}
                      nextLabel={"›"}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={(e) => setCurrentPage(e.selected)}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* Reusable Delete Confirmation Modal */}
      <ConfirmModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={handleDeleteShipping}
        title="Confirm Deletion"
        message="Are you sure you want to delete this coupon?"
      />
    </>
  );
}

export default Shippingchargeslist;
